import { Provider } from '@angular/core';

import { MOMO_MANAGE_VACATIONS_USE_CASES } from '@app/domain/use-cases/manage-vacations/momo/momo-manage-vacations.use-cases.contract';
import { MomoManageVacationsUseCasesImpl } from '@app/domain/use-cases/manage-vacations/momo/momo-manage-vacatios.use-cases';

export const momoManageVacationsUseCasesProvider: Provider = {
  provide: MOMO_MANAGE_VACATIONS_USE_CASES,
  useClass: MomoManageVacationsUseCasesImpl
};
